import { formatToTimeZone } from 'date-fns-timezone'

const formatToLocalTimezone = (date, format) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatToTimeZone(date, format, { timeZone })
}

export default formatToLocalTimezone
